import { Timestamp } from '../services/Timestamp';

export enum Queries {
  Secret = 'secret',
  Settings = 'settings',
  PlaybackData = 'playback-data',
  LiveData = 'live-data',
  TidalData = 'tidal-data',
  TideInfo = 'tide-info',
  TripsEcoRating = 'trips-eco-rating',
  TripsPaginated = 'trips-paginated',
  JobVesselTracks = 'job-vessel-tracks',
  LiveVesselTracks = 'live-vessel-tracks',
  Operations = 'operations',
  Vessels = 'vessels',
  SearchVessel = 'search-vessel',
  SearchOperation = 'search-operation',
  SearchTripOrJob = 'search-trip-or-job',
}

export interface QueryCacheOptions {
  staleTime?: number;
  cacheTime?: number;
}

const playbackStaleTime = Timestamp.fromMinutes(15).toMilliseconds();

export const QueryCacheConfig: Record<Queries, QueryCacheOptions> = {
  [Queries.Secret]: { staleTime: Infinity },
  [Queries.Settings]: { staleTime: Infinity },
  [Queries.PlaybackData]: { staleTime: playbackStaleTime },
  [Queries.LiveData]: { staleTime: 0, cacheTime: 0 },
  [Queries.TidalData]: { staleTime: playbackStaleTime },
  [Queries.TideInfo]: { staleTime: Infinity },
  [Queries.TripsEcoRating]: { staleTime: Timestamp.fromMinutes(10).toMilliseconds() },
  [Queries.TripsPaginated]: { staleTime: Timestamp.fromMinutes(30).toMilliseconds() },
  [Queries.JobVesselTracks]: { staleTime: 0 },
  [Queries.LiveVesselTracks]: { staleTime: Timestamp.fromMinutes(10).toMilliseconds() },
  [Queries.Operations]: { staleTime: Infinity },
  [Queries.Vessels]: { staleTime: Infinity },
  [Queries.SearchVessel]: { staleTime: Timestamp.fromMinutes(30).toMilliseconds() },
  [Queries.SearchOperation]: { staleTime: Timestamp.fromMinutes(30).toMilliseconds() },
  [Queries.SearchTripOrJob]: { staleTime: Timestamp.fromMinutes(30).toMilliseconds() },
};
